// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(tabs)/_layout.tsx": { enumerable: true, get() { return require("/vercel/path0/src/app/(tabs)/_layout.tsx"); } },
  "./(tabs)/create.tsx": { enumerable: true, get() { return require("/vercel/path0/src/app/(tabs)/create.tsx"); } },
  "./(tabs)/index.tsx": { enumerable: true, get() { return require("/vercel/path0/src/app/(tabs)/index.tsx"); } },
  "./(tabs)/profile.tsx": { enumerable: true, get() { return require("/vercel/path0/src/app/(tabs)/profile.tsx"); } },
  "./(tabs)/settings.tsx": { enumerable: true, get() { return require("/vercel/path0/src/app/(tabs)/settings.tsx"); } },
  "./(tabs)/zones.tsx": { enumerable: true, get() { return require("/vercel/path0/src/app/(tabs)/zones.tsx"); } },
  "./[...slug].tsx": { enumerable: true, get() { return require("/vercel/path0/src/app/[...slug].tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("/vercel/path0/src/app/_layout.tsx"); } },
  "./groupSelector.tsx": { enumerable: true, get() { return require("/vercel/path0/src/app/groupSelector.tsx"); } },
  "./page/[slug].tsx": { enumerable: true, get() { return require("/vercel/path0/src/app/page/[slug].tsx"); } },
  "./post/[id].tsx": { enumerable: true, get() { return require("/vercel/path0/src/app/post/[id].tsx"); } },
  "./zone/[id].tsx": { enumerable: true, get() { return require("/vercel/path0/src/app/zone/[id].tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;